

















import { Component, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';

import DxForm, { DxLabel, DxSimpleItem } from 'devextreme-vue/form';
import { CreateRawMaterialGroupCommand, RawMaterialGroupsClient, RawMaterialGroupTunnelGroup, TunnelGroup } from '@/data/web-api-client';

@Component({
  components: {
    Popup,
    DxForm,
    DxSimpleItem,
    DxLabel,
  },
})
export default class AddRawMaterialGroupsDialog extends Vue {
  @Prop()
  show!: boolean;

  @Prop({ required: true })
  tunnelGroups: any;

  saving = false;

  numberBoxOptions = {
    step: 0,
  };

  formData: any = {
    name: '',
  };

  private created() {
    for (const tunnelGroup of this.tunnelGroups!) {
      this.formData[`${tunnelGroup!.name!}`] = 0;
    }
  }

  private rawMaterialGroupsClient: RawMaterialGroupsClient = new RawMaterialGroupsClient(undefined, this.$axios);

  async save() {
    try {
      const data = {
        name: this.formData.name,
        margin: this.formData.margin,
        tunnelGroups: this.tunnelGroups.map((tg: any) => ({id: tg.id, discountValue: this.formData[tg.name]}))
      };

      const command = new CreateRawMaterialGroupCommand(CreateRawMaterialGroupCommand.fromJS(data));

      const result = await this.rawMaterialGroupsClient.createRawMaterialGroup(command);

      // this.$emit('save', result);

      this.hide();
    } catch (err) {
    } finally {
      this.saving = false;
    }
  }

  hide() {
    this.clearForm();

    this.$emit('close');
  }

  clearForm() {
    this.formData = {
      name: '',
      margin: 0,
    };
  }
}
